export enum ScheduledJobType {
	FirmwareUpdate = 'FIRMWARE_UPDATE'
}

export enum ScheduledJobStatus {
	Pending = 'PENDING',
	Executing = 'EXECUTING',
	Completed = 'COMPLETED',
	Failed = 'FAILED',
	Cancelled = 'CANCELLED',
	Missed = 'MISSED'
}

export interface ScheduledJob {
	id: string;
	jobId: string;
	name: string;
	type: ScheduledJobType;
	status: ScheduledJobStatus;
	requestCount: number;
	executeAt: Date;
	createdBy: string;
	createdAt: Date;
	updatedBy: string;
	updatedAt: Date;
}

export interface ScheduledJobRequest {
	id: string;
	status: ScheduledJobStatus;
	jobId: string;
}

export interface FirmwareUpdateJobRequest extends ScheduledJobRequest {
	packageKey: string;
	packageVersion: string;
	hosted: boolean;
	deviceHardwareId: string;
}
